import { render } from "./PopupThongTinTheKiemSoat.vue?vue&type=template&id=fadd0672"
import script from "./PopupThongTinTheKiemSoat.vue?vue&type=script&lang=js"
export * from "./PopupThongTinTheKiemSoat.vue?vue&type=script&lang=js"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__